import { render, staticRenderFns } from "./RightPanelGlobal.vue?vue&type=template&id=5b80cfc6&"
import script from "./RightPanelGlobal.vue?vue&type=script&lang=js&"
export * from "./RightPanelGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports